import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/admin`;

export const adminApi = {
  // Blog Posts
  getAllBlogPosts: async (token) => {
    const response = await axios.get(`${API}/blog`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.posts;
  },

  createBlogPost: async (token, post) => {
    const response = await axios.post(`${API}/blog`, post, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateBlogPost: async (token, postId, post) => {
    const response = await axios.put(`${API}/blog/${postId}`, post, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  deleteBlogPost: async (token, postId) => {
    const response = await axios.delete(`${API}/blog/${postId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Testimonials
  getAllTestimonials: async (token) => {
    const response = await axios.get(`${API}/testimonials`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.testimonials;
  },

  createTestimonial: async (token, testimonial) => {
    const response = await axios.post(`${API}/testimonials`, testimonial, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateTestimonial: async (token, testimonialId, testimonial) => {
    const response = await axios.put(`${API}/testimonials/${testimonialId}`, testimonial, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  deleteTestimonial: async (token, testimonialId) => {
    const response = await axios.delete(`${API}/testimonials/${testimonialId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Regions
  getAllRegions: async (token) => {
    const response = await axios.get(`${API}/regions`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.regions;
  },

  createRegion: async (token, region) => {
    const response = await axios.post(`${API}/regions`, region, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateRegion: async (token, regionId, region) => {
    const response = await axios.put(`${API}/regions/${regionId}`, region, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  deleteRegion: async (token, regionId) => {
    const response = await axios.delete(`${API}/regions/${regionId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Contacts
  getAllContacts: async (token) => {
    const response = await axios.get(`${BACKEND_URL}/api/contact`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.submissions;
  },

  // Home Content
  getHeroSection: async (token) => {
    const response = await axios.get(`${API}/home-content/hero`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateHeroSection: async (token, data) => {
    const response = await axios.put(`${API}/home-content/hero`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getIntroSection: async (token) => {
    const response = await axios.get(`${API}/home-content/intro`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateIntroSection: async (token, data) => {
    const response = await axios.put(`${API}/home-content/intro`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getAboutSection: async (token) => {
    const response = await axios.get(`${API}/home-content/about`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateAboutSection: async (token, data) => {
    const response = await axios.put(`${API}/home-content/about`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getStatsSection: async (token) => {
    const response = await axios.get(`${API}/home-content/stats`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateStatsSection: async (token, data) => {
    const response = await axios.put(`${API}/home-content/stats`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getHeaderFooter: async (token) => {
    const response = await axios.get(`${API}/home-content/header-footer`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateHeaderFooter: async (token, data) => {
    const response = await axios.put(`${API}/home-content/header-footer`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Services Section
  getServicesSection: async (token) => {
    const response = await axios.get(`${API}/home-content/services`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateServicesSection: async (token, data) => {
    const response = await axios.put(`${API}/home-content/services`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Decorative Section
  getDecorativeSection: async (token) => {
    const response = await axios.get(`${API}/home-content/decorative`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateDecorativeSection: async (token, data) => {
    const response = await axios.put(`${API}/home-content/decorative`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Upload de Imagens
  uploadImage: async (token, formData) => {
    const response = await axios.post(`${BACKEND_URL}/api/admin/upload`, formData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  uploadMultipleImages: async (token, formData) => {
    const response = await axios.post(`${BACKEND_URL}/api/admin/upload/multiple`, formData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // User Management
  getAllUsers: async (token) => {
    const response = await axios.get(`${API}/users`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  createUser: async (token, userData) => {
    const response = await axios.post(`${API}/users`, userData, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateUser: async (token, userId, userData) => {
    const response = await axios.put(`${API}/users/${userId}`, userData, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  deleteUser: async (token, userId) => {
    const response = await axios.delete(`${API}/users/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  updateUserPassword: async (token, userId, password) => {
    const response = await axios.put(`${API}/users/${userId}/password`, { password }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};
